"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 14 10" id=icon-tick><path d="M5 10a.999.999 0 01-.71-.29l-4-4A1 1 0 011.7 4.3L5 7.59 12.29.3a1 1 0 011.41 1.41l-8 8A.999.999 0 015 10z"></path></symbol>';
}